import { UserCommand } from './UserCommand';
import { CreateUserCommand } from './CreateUserCommand';
import { RevenueCommand } from './RevenueCommand';
import { SearchCommand } from './SearchCommand';
import { OrganizationCommand } from './OrganizationCommand';

export const commands = [
  new UserCommand().getKeywords(),
  new CreateUserCommand().getKeywords(),
  new RevenueCommand().getKeywords(),
  new SearchCommand().getKeywords(),
  new OrganizationCommand().getKeywords(),
].map((cmd) => cmd.join(' '));
